export default "__VITE_ASSET__DaBcw8va__"